import { getNumber, getJson, numConvert } from "@/method";

export function compute(monthDataAll = {}, thisData = []) {
    const { lastMonthData = [] } = monthDataAll;
    const monthData = !monthDataAll.data || monthDataAll.data.length <= 0 ? lastMonthData : monthDataAll.data;
    let data = thisData;

    const controlName = [
        { name: "best", index: 0 },
        { name: "corporate", index: 1 },
        { name: "government", index: 2 },
        { name: "packges", index: 3 },
        { name: "wholesale", index: 4 },
        { name: "commerce", index: 5 },
        { name: "discounts", index: 6 },
        { name: "business", index: 8 },
        { name: "leisure", index: 9 },
    ];
    // 从月度表格更新数据
    controlName.forEach(item => {
        data[item.index].budget_r_nts = getNumber([41, item.name + "_rn"], monthData).toFixed(2);
        data[item.index].budget_rev = getNumber([41, item.name + "_rev"], monthData).toFixed(2);
        data[item.index].sum_r_nts = getNumber([40, item.name + "_rn"], monthData).toFixed(2);
        data[item.index].sum_rev = getNumber([40, item.name + "_rev"], monthData).toFixed(2);
    });

    data[11].budget_r_nts = getNumber([41, 'contracts_rn'], monthData).toFixed(2);
    data[11].budget_rev = (numConvert(getNumber([41, 'contracts_rev'], monthData)) + numConvert(getNumber([41, 'others_rev'], monthData))).toFixed(2);
    data[11].sum_r_nts = getNumber([40, 'contracts_rn'], monthData).toFixed(2);
    data[11].sum_rev = (numConvert(getNumber([40, 'contracts_rev'], monthData)) + numConvert(getNumber([40, 'others_rev'], monthData))).toFixed(2);

    data[13].budget_r_nts = getNumber([41, 'grand_rms'], monthData).toFixed(2);
    data[13].sum_r_nts = getNumber([40, 'grand_rms'], monthData).toFixed(2);

    // 计算其他项目结果
    const totalName = ['budget_r_nts', 'budget_rev', 'sum_r_nts', 'sum_rev'];
    totalName.forEach(name => {
        data[7][name] = data.reduce((a, b, i) => {
            if (i < 7) {
                a += numConvert(b[name]);
            }
            return a;
        }, 0).toFixed(2);
        data[10][name] = data.reduce((a, b, i) => {
            if (i < 10 && i > 7) {
                a += numConvert(b[name]);
            }
            return a;
        }, 0).toFixed(2);
        data[12][name] = [7, 10, 11].reduce((a, b) => (a + numConvert(data[b][name])), 0).toFixed(2);
    });

    ['budget_r_nts', 'sum_r_nts'].forEach(name => {
        const ARR = name.split('_')[0] + "_arr";
        data[14][name] = data[13][name] == 0 ? 0 : (data[12][name] / data[13][name]).toFixed(4);
        data[15][name] = (data[14][name] * data[12][ARR]).toFixed(4);
    });

    // 计算DIff RN REV
    ['diff_r_nts', 'diff_rev'].forEach(name => {
        const budget = 'budget_' + name.split('diff_')[1];
        const sum = 'sum_' + name.split('diff_')[1];
        data.forEach((item, i) => {
            data[i][name] = (item[sum] - item[budget]).toFixed(2);
        })
    });

    // Mix ARR  
    data.forEach((item, i) => {
        if (i < 13) {
            data[i].budget_nts_mix = data[12].budget_r_nts == 0 ? 0 : (data[i].budget_r_nts / data[12].budget_r_nts).toFixed(4);
            data[i].budget_arr = data[i].budget_r_nts == 0 ? 0 : (data[i].budget_rev / data[i].budget_r_nts).toFixed(2);
            data[i].budget_rev_mix = data[12].budget_rev == 0 ? 0 : (data[i].budget_rev / data[12].budget_rev).toFixed(4);

            data[i].sum_nts_mix = data[12].sum_r_nts == 0 ? 0 : (data[i].sum_r_nts / data[12].sum_r_nts).toFixed(4);
            data[i].sum_arr = data[i].sum_r_nts == 0 ? 0 : (data[i].sum_rev / data[i].sum_r_nts).toFixed(2);
            data[i].sum_rev_mix = data[12].sum_rev == 0 ? 0 : (data[i].sum_rev / data[12].sum_rev).toFixed(4);

            // diff
            data[i].diff_arr = (data[i].sum_arr - data[i].budget_arr).toFixed(2);
            data[i].diff_arr_mix = data[i].budget_arr == 0 ? 0 : (data[i].diff_arr / data[i].budget_arr).toFixed(4);
            data[i].diff_rev_mix = data[i].budget_rev == 0 ? 0 : (data[i].diff_rev / data[i].budget_rev).toFixed(4);
        }

        data[i].diff_nts_mix = data[i].budget_r_nts == 0 ? 0 : (data[i].diff_r_nts / data[i].budget_r_nts).toFixed(4);
    });

    return data
}



export function computeNew(monthDataAll = {}, thisData = []) {
    const { lastMonthData = [] } = monthDataAll;
    const monthData = !monthDataAll.data || monthDataAll.data.length <= 0 ? lastMonthData : monthDataAll.data;
    let data = thisData;
    if (data.length == 16) {
        data[11].name = 'CONTRACT';
        data.splice(12, 0, {
            name: 'OTHERS',
            sort: 12,
            budget_r_nts: 0,
            budget_nts_mix: 0,
            budget_arr: 0,
            budget_rev: 0,
            budget_rev_mix: 0,
            sum_r_nts: 0,
            sum_nts_mix: 0,
            sum_arr: 0,
            sum_rev: 0,
            sum_rev_mix: 0,
            diff_r_nts: 0,
            diff_nts_mix: 0,
            diff_arr: 0,
            diff_arr_mix: 0,
            diff_rev: 0,
            diff_rev_mix: 0,
        });
        data = data.map((x, i) => ({ ...x, sort: i }));
    }
    const controlName = [
        { name: "best", index: 0 },
        { name: "corporate", index: 1 },
        { name: "government", index: 2 },
        { name: "packges", index: 3 },
        { name: "wholesale", index: 4 },
        { name: "commerce", index: 5 },
        { name: "discounts", index: 6 },
        { name: "business", index: 8 },
        { name: "leisure", index: 9 },
        { name: "contracts", index: 11 },
    ];
    // 从月度表格更新数据
    controlName.forEach(item => {
        data[item.index].budget_r_nts = getNumber([41, item.name + "_rn"], monthData).toFixed(2);
        data[item.index].budget_rev = getNumber([41, item.name + "_rev"], monthData).toFixed(2);
        data[item.index].sum_r_nts = getNumber([40, item.name + "_rn"], monthData).toFixed(2);
        data[item.index].sum_rev = getNumber([40, item.name + "_rev"], monthData).toFixed(2);
    });

    data[12].budget_rev = getNumber([41, 'others_rev'], monthData);
    data[12].sum_rev = getNumber([40, 'others_rev'], monthData);
    data[12].budget_r_nts = 0;
    data[12].sum_r_nts = 0;

    data[14].budget_r_nts = getNumber([41, 'grand_rms'], monthData).toFixed(2);
    data[14].sum_r_nts = getNumber([40, 'grand_rms'], monthData).toFixed(2);

    // 计算其他项目结果
    const totalName = ['budget_r_nts', 'budget_rev', 'sum_r_nts', 'sum_rev'];
    totalName.forEach(name => {
        data[7][name] = data.reduce((a, b, i) => {
            if (i < 7) {
                a += numConvert(b[name]);
            }
            return a;
        }, 0).toFixed(2);
        data[10][name] = data.reduce((a, b, i) => {
            if (i < 10 && i > 7) {
                a += numConvert(b[name]);
            }
            return a;
        }, 0).toFixed(2);
        data[13][name] = [7, 10, 11, 12].reduce((a, b) => (a + numConvert(data[b][name])), 0).toFixed(2);
    });

    ['budget_r_nts', 'sum_r_nts'].forEach(name => {
        const ARR = name.split('_')[0] + "_arr";
        data[15][name] = data[14][name] == 0 ? 0 : (data[13][name] / data[14][name]).toFixed(4);
        data[16][name] = (data[15][name] * data[13][ARR]).toFixed(4);
    });

    // 计算DIff RN REV
    ['diff_r_nts', 'diff_rev'].forEach(name => {
        const budget = 'budget_' + name.split('diff_')[1];
        const sum = 'sum_' + name.split('diff_')[1];
        data.forEach((item, i) => {
            data[i][name] = (item[sum] - item[budget]).toFixed(2);
        })
    });

    // Mix ARR  
    data.forEach((item, i) => {
        if (i < 14) {
            data[i].budget_nts_mix = data[13].budget_r_nts == 0 ? 0 : (data[i].budget_r_nts / data[13].budget_r_nts).toFixed(4);
            data[i].budget_arr = data[i].budget_r_nts == 0 ? 0 : (data[i].budget_rev / data[i].budget_r_nts).toFixed(2);
            data[i].budget_rev_mix = data[13].budget_rev == 0 ? 0 : (data[i].budget_rev / data[13].budget_rev).toFixed(4);

            data[i].sum_nts_mix = data[13].sum_r_nts == 0 ? 0 : (data[i].sum_r_nts / data[13].sum_r_nts).toFixed(4);
            data[i].sum_arr = data[i].sum_r_nts == 0 ? 0 : (data[i].sum_rev / data[i].sum_r_nts).toFixed(2);
            data[i].sum_rev_mix = data[13].sum_rev == 0 ? 0 : (data[i].sum_rev / data[13].sum_rev).toFixed(4);

            // diff
            data[i].diff_arr = (data[i].sum_arr - data[i].budget_arr).toFixed(2);
            data[i].diff_arr_mix = data[i].budget_arr == 0 ? 0 : (data[i].diff_arr / data[i].budget_arr).toFixed(4);
            data[i].diff_rev_mix = data[i].budget_rev == 0 ? 0 : (data[i].diff_rev / data[i].budget_rev).toFixed(4);
        }

        data[i].diff_nts_mix = data[i].budget_r_nts == 0 ? 0 : (data[i].diff_r_nts / data[i].budget_r_nts).toFixed(4);
    });

    return data
}




// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-3/compute.js